import { createContext, useContext } from 'react';

import type { EnrichmentContext } from '../types/enrichment-context.types';

/** React context carrying the host-injected enrichment session contract. */
export const EnrichmentCtx = createContext<EnrichmentContext | null>(null);

/**
 * Reads the injected {@link EnrichmentContext}. Must be called inside a
 * component tree that has an {@link EnrichmentCtx}.Provider ancestor — throws
 * otherwise so misconfigured trees fail loudly rather than silently.
 */
export function useEnrichmentContext(): EnrichmentContext {
  const ctx = useContext(EnrichmentCtx);
  if (!ctx) {
    throw new Error(
      'useEnrichmentContext must be called inside an EnrichmentCtx.Provider. ' +
        'Each route that renders the content-enrichment funnel must wrap it with ' +
        'the appropriate adapter provider (e.g. ExperimentContentEnrichmentProvider).',
    );
  }
  return ctx;
}
